export enum CurrencyCode {
  BTC = "BTC",
  CZK = "CZK",
  EUR = "EUR",
  GBP = "GBP",
  PLN = "PLN",
  CHF = "CHF",
}
